export default __webpack_public_path__ + "static/media/tixk-circle.f29afbec.svg";